export default {
    general: {
        add:     'Add',
        edit:    'Edit',
        delete:  'Delete',
        cancel:  'Cancel',
        save:    'Save',
        close:   'Close',
        confirm: 'Confirm',
        yes:     'Yes',
        no:      'No',
        back:    'Back',
        show_password: 'Show password',
        hide_password: 'Hide password',
        no_data: 'No data',
        loading: 'Loading …',
        today:   'Today',
        status:  'Status',
        refresh: 'Refresh',
        search:  'Search',
    },
    // A length of time the way a hotel says it: "18 min" under the hour, "1 h 05" over
    // it. The minutes are padded, because "1 h 5" reads as an hour and five hours.
    duration: {
        minutes: '{minutes} min',
        hours:   '{hours} h {minutes}',
    },
    // Maintenance: what is broken and who is mending it.
    maintenance: {
        title:              'Maintenance',
        description:        'What is broken and who is mending it.',
        report:             'Report a fault',
        reported:           'The fault has been reported.',
        fault:              'Fault',
        area:               'Part of the building',
        area_hint:          'When it is not a room — the lift, the kitchen, the car park …',
        room_hint:          'Leave empty when the fault is not in a room.',
        no_room:            'No room',
        description_label:  'Description',
        severity:           'Severity',
        severity_blocking:  'Blocks the room',
        severity_normal:    'Normal',
        severity_cosmetic:  'Cosmetic',
        status_open:        'Reported',
        status_assigned:    'Assigned',
        status_in_progress: 'In progress',
        status_resolved:    'Repaired',
        status_closed:      'Closed',
        status_cancelled:   'Cancelled',
        status_duplicate:   'Duplicate',
        start:              'Take it',
        started:            'The fault has been taken up.',
        resolve:            'Repaired',
        resolved:           'The fault is marked as repaired.',
        resolution:         'What was done',
        resolution_hint:    'A short note for whoever sees the same fault six months from now.',
        nobody:             'Nobody',
        empty:              'No open faults.',
        filter_mine:        'Mine',
        filter_unassigned:  'Unassigned',
        filter_open:        'All open',
        load_failed:        'The faults could not be loaded.',
        action_failed:      'That could not be done.',
    },
    room: {
        room: 'Room',
    },
    nav: {
        calendar:   'Calendar',
        services:    'Services',
        maintenance: 'Maintenance',
        logout:       'Log out',
        theme:        'Theme',
        theme_light:  'Light',
        theme_dark:   'Dark',
        theme_system: 'System',
        language:     'Language',
        language_sl:  'Slovenian',
        language_en:  'English',
        today:        'Today',
        sheet:        'Schedule',
        statistics:   'Statistics',
        timeline:   'Timeline',
    },
    login: {
        title:    'Sign in',
        subtitle: 'Portal for the people who work the facilities — wellness, hire, halls',
        username: 'Username',
        password: 'Password',
        submit:   'Sign in',
        failed:   'Wrong username or password',
    },
    property: {
        property:   'Property',
        properties: 'Properties',

        unavailable_title:       'The property is not known',
        unavailable_description: 'This account cannot read the list of properties (it is missing property:read), so the portal does not know which house it is in. Ask an administrator.',

        rooms_restricted_title:       'Room numbers are unavailable',
        rooms_restricted_description: 'Some tasks carry no room number. The work is shown, but the room has to be looked up.',
    },
    today: {
        title:    'Today',
        subtitle: 'Rooms for today’s business date',

        progress: 'Finished',

        my_rooms:               'My rooms',
        unassigned_rooms:       'Unassigned rooms',
        unassigned_description: 'These rooms are not on anybody’s round yet. Press Start to take one.',

        floor:         'Floor {floor}',
        floor_unknown: 'Unknown floor',

        empty: 'There are no rooms for you today.',
    },
    sheet: {
        title:    'Schedule',
        subtitle: 'Every room of today’s business date',

        generate:         'Generate the schedule',
        generate_confirm: 'Generate the tasks for today’s business date. Tasks that already exist are left untouched.',
        generate_failed:  'The schedule could not be generated.',
        generated_message: 'Tasks created: {count}',

        filter_status: 'Status',
        filter_kind:   'Kind of work',
        all_statuses:  'All statuses',
        all_kinds:     'All kinds of work',
        floor_summary:  '{rooms} rooms · {open} to do',
        person_summary: 'still to do: {open} of {total}',
        group_by_floor:  'By floor',
        group_by_person: 'By person',

        empty: 'There are no tasks for this day. If the night audit has not run, press Generate the schedule.',

        assign_restricted_title:       'Assignment is unavailable',
        assign_restricted_description: 'This account cannot read this property\'s housekeepers (it is missing housekeeping:inspect), so rooms cannot be assigned.',
    },
    timeline: {
        search: 'Room or person',
        no_match: 'Nothing matches that search.',
        title:       'The day in order',
        description: 'When each room came into work, who took it and made it up, and who accepted it.',
        empty:       'Nothing has happened yet today.',
        started:     'taken for cleaning',
        finished:    'made up',
        skipped:     'skipped',
        inspected:   'accepted',
        days_today: 'Today',
        days_3: 'Last 3 days',
        days_7: 'Last 7 days',
        days_14: 'Last 14 days',
    },
    task: {
        status_pending:     'Waiting',
        status_in_progress: 'In progress',
        status_done:        'Finished',
        status_inspected:   'Inspected',
        status_skipped:     'Skipped',

        kind_departure: 'Departure',
        kind_stayover:  'Stayover',
        kind_arrival:   'Arrival',
        kind_dirty:             'To prepare',
        kind_dirty_done:        'Prepared',

        kind_departure_description: 'The guest has left. Strip and make up the whole room: bed, bathroom and supplies.',
        kind_stayover_description:  'The guest is staying. Daily service around their own things — bed, bathroom, bins, towels.',
        kind_arrival_description:   'The room is empty and a guest arrives today. Prepare it and look it over before they walk in.',
        kind_dirty_description: 'The room is waiting to be prepared although nobody stayed and nobody is arriving today. Take it all the way.',

        consequence_done:           'The room is cleaned. Once a supervisor accepts it, it is ready for the next guest.',
        consequence_inspected:      'The room is accepted and ready for the next guest.',
        consequence_stayover_done:  'The daily service is done, but the room stays occupied — it is not ready for a new guest.',
        guest_still_in_room:        'The guest is still in the room',

        room_unknown: 'Unknown room',
        floor:         'Floor',
        business_date: 'Business date',
        started_at:    'Started',
        finished_at:   'Finished',
        inspected_at:  'Inspected',
        notes:         'Note',

        // The norm is a planning aid and not a mark against anybody. Nothing here is
        // worded as a reprimand: a room past its norm is a room the norm did not
        // describe, which is as often the room's doing as the housekeeper's.
        norm:       'Norm',
        norm_short: 'norm {value}',
        remaining:              '{value} left',
        over_by:                '{value} over',
        over_norm:  '{value} over the norm',
        elapsed:    'Running',
        duration:   'Took',

        unassigned:        'Unassigned',
        worked_by:              'Cleaned by {name}',
        awaiting_inspection:    'Waiting to be checked',

        due_by:                 'by {time}',

        priority:               'Priority',
        assigned_to:       'Assigned to',
        assigned_to_you:   'You',
        assigned_to_other: 'Somebody else',

        assign:           'Assign',
        assign_to:        'Assign to',
        assigned_message: 'The room has been assigned',

        actions: 'Actions',

        start:            'Start',
        started_message:  'The room has been started',

        finish:           'Finish',
        finished_message: 'The room has been finished',

        finish_without_start:         'The work is already done',
        finish_without_start_confirm: 'This room has not been started. It will be recorded as started now and finished immediately, so the cleaning time will not be right. If you are only starting the work, press Start instead.',

        skip:            'Skip',
        skip_confirm:    'The room will not be cleaned. Write down the reason so the supervisor knows why.',
        skipped_message: 'The room has been skipped',

        inspect:           'Accept room',
        inspect_confirm:   'This states that you have inspected the room and it is ready for a guest. It cannot be undone.',
        inspected_message: 'The room has been accepted',

        note_title: 'Note',
        note_hint:  'What you write is sent together with Finish or Skip, and the supervisor reads it.',

        reason_do_not_disturb: 'Do not disturb',
        reason_guest_declined: 'The guest declined cleaning',
        reason_no_access:      'The room could not be accessed',

        not_found:  'The task could not be found.',
        no_actions: 'There is nothing you may do on this room.',

        closed_done:      'The room is cleaned and waiting for the supervisor to look at it.',
        closed_inspected: 'The room has been inspected. The work here is finished for today.',
        closed_skipped:   'The room was skipped. There is nothing more to do here today.',

        load_failed:   'The tasks could not be loaded.',
        action_failed: 'The action could not be carried out.',
    },
    statistics: {
        title:    'Statistics',
        subtitle: 'The work done, by person, by kind and by day',

        period_today: 'Today',
        period_week:  '7 days',
        period_month: 'This month',

        range: '{from} to {to}',

        tasks:     'Rooms',
        done:      'Cleaned',
        inspected: 'Inspected',
        skipped:   'Skipped',

        average:    'Average per room',
        norm:       'Norm per room',
        norm_short: 'norm {value}',
        per_room:   'per room',
        worked:     'Time worked',
        // The denominator, said out loud: an average over four rooms and an average
        // over forty are different facts and must not be allowed to look alike.
        timed:      'Rooms timed',

        by_person:      'By person',
        by_person_hint: 'Work counts for whoever did it — whoever pressed Start. Rooms nobody started are in the Unassigned row.',
        by_kind:        'By kind of work',
        by_day:         'By day',

        unassigned:     'Unassigned',
        person_unknown: 'Unknown person',

        empty:       'No work was recorded in this period.',
        load_failed: 'The statistics could not be loaded.',
    },
    calendar: {
        title: 'Diary',
        description: 'What is free and what is taken in the facility.',
        no_centres: 'This account is not tied to any facility.',
        empty: 'Nothing is open on this day.',
        time: 'Time',
        resource: 'Resource',
        free: 'free',
        legend_booked: 'booked',
        legend_out: 'out / under way',
        legend_done: 'returned / finished',
        taken: 'taken',
    },
    service: {
        title: 'My services',
        description: 'The appointments you are giving today, in the order of the clock.',
        empty: 'Nothing booked for this day.',
        today: 'Today',
        tomorrow: 'Tomorrow',
        view_day: 'Day',
        view_week: 'Week',
        view_month: 'Month',
        includes_today: 'Includes today',
        period_count: 'Appointments: {count}',
        period_hours: '{hours} h in total',
        previous_day: 'Previous day',
        next_day: 'Next day',
        all_day: 'All day',
        days_count: '{count} days',
        hand_over: 'Hand over',
        handed_over: 'Handed over',
        handed_over_done: 'Handed over to the guest.',
        take_back: 'Take back',
        returned: 'Returned',
        returned_done: 'Recorded as returned.',
        to_hand_over: 'To hand over',
        hire_hours: 'Out {pickup} · back {back}',
        walk_in: 'No guest named',
        status_booked: 'Booked',
        status_in_progress: 'Under way',
        status_completed: 'Finished',
        start: 'Start',
        book: 'Book',
        booked: 'The appointment is booked',
        book_title: 'New appointment',
        book_service: 'Service',
        book_guest: 'Guest',
        book_guest_hint: 'The name as the guest gives it. May be left empty.',
        book_time: 'Free times',
        book_source: 'Who asked for it',
        source_walk_in: 'Guest here with me',
        source_phone: 'On the telephone',
        book_no_slots: 'Nothing free on this day.',
        book_failed: 'The appointment could not be booked.',
        book_no_second: 'No second therapist is free at that hour. Choose another one.',
        started: 'The service is under way',
        finished: 'The service is finished',
        finish: 'Finish',
        finish_title: 'Finish the service',
        finish_question: 'How did the guest pay?',
        finish_free_hint: 'This service has no price — it is finished without a charge.',
        settle_folio: 'On the room',
        settle_folio_hint: 'It goes on the guest\'s card and is paid at check-out.',
        settle_folio_no_stay: 'Not possible — this appointment has no stay behind it.',
        settle_paid: 'Immediate payment',
        settle_paid_hint: 'Nothing goes on a card.',
    },
    license: {
        title:   'This service is not enabled',
        lead:    'Groups and events are not part of this hotel’s subscription, so this portal has nothing to show.',
        switch_account: 'Sign in with another account',
        contact: 'Contact your system administrator to have it switched on. The hotel’s data is untouched.',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'You are not allowed to do that',
        session_expired: 'The session has expired. Sign in again — nothing was done.',
        conflict:      'The record already exists',
        on_add:        'Error while adding',
        on_load:       'The data could not be read',
        on_edit:       'Error while saving',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully saved',
    },
    validation: {
        required: 'This field is required',
        email:    'Invalid email address',
    },
}
